<template>
  <file-names-list
    v-if="selectedMsp.id"
    :tier="tierType"
    :id="selectedMsp.id"
  />
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import FileNamesList from "@/views/Common/AttachmentFilters/FileName.vue";

import { TIER } from "@/constants";

export default {
  name: "FileNames",
  components: {
    FileNamesList,
  },
  data() {
    return {
      tierType: TIER.msps,
    };
  },
  computed: {
    ...mapGetters("authentication", ["selectedMsp"]),
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
  },
  created() {
    this.setPageTitle(this.$t("Attachments"));
    this.setPageSubtitle([]);
  },
};
</script>
